import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';

import { Message } from '@graphql/generated';

export const getMessageFromCache = (
  client: ApolloClient<NormalizedCacheObject>,
  cacheIdentifier: string | null | undefined
): Message | undefined | null => {
  if (!cacheIdentifier) return null;

  return client.cache.readFragment({
    id: cacheIdentifier,
    fragment: MessageDetailForQueryFragmentDoc1,
    fragmentName: 'MessageDetailForCache',
    returnPartialData: true,
  });
};

export const MessageDetailForQueryFragmentDoc1 = gql`
  fragment MessageDetailForCache on Message {
    id
    chatId
    clientId
    body
    createdAt
    isSender
    isDraft
    publishedAt
    authorId
    authorAvatarId
    authorName
    authorFirstName
    authorLastName
    authorEmail
    readAt
    isRetry
    readReceipts {
      ...UserDetail
    }
    checkin {
      ...checkinDetail
    }
    replyId
    userRequest {
      id
      requestType
      status
      reviewedBy {
        id
        name
      }
      user {
        id
        email
        name
      }
      userRequestableId
      userRequestableType
    }
    replyMessage {
      id
      chatId
      clientId
      body
      createdAt
      isSender
      isDraft
      publishedAt
      authorId
      authorFirstName
      attachments {
        ... on MessageTask {
          id
          authorId
          author {
            id
            name
            avatar {
              ...AvatarDetail
            }
          }
          task {
            id
            projectId
            name
          }
        }
        ... on MessageProject {
          id
          authorId
          author {
            id
            name
            avatar {
              ...AvatarDetail
            }
          }
          project {
            id
            uuid
            name
          }
        }
        ... on Document {
          id
          name
          contentType
          createdAt
          size
          isImage
          clientId
          isAudio
          duration
          file {
            id
            cdnBaseUrl
            url
            isPreviewable
            thumbnail
          }
          owner {
            id
            name
            firstName
            lastName
            createdAt
          }
        }
        ... on MessageTaskAssignment {
          id
          messageId
          assignees {
            ...UserDetail
          }
          task {
            id
            name
            deletedAt
            completedAt
          }
        }
        ... on MessageTaskComplete {
          id
          messageId
          completor {
            id
            name
            avatar {
              ...AvatarDetail
            }
          }
        }
      }
    }
    attachments {
      ... on MessageTask {
        id
        authorId
        author {
          id
          name
          avatar {
            ...AvatarDetail
          }
        }
        task {
          id
          projectId
          deletedAt
          name
          priority
          dueDate
          members {
            id
            role
            user {
              id
              name
              avatar {
                ...AvatarDetail
              }
            }
          }
        }
      }
      ... on MessageProject {
        id
        authorId
        author {
          id
          name
          avatar {
            ...AvatarDetail
          }
        }
        project {
          id
          uuid
          name
        }
      }
      ... on Document {
        id
        blobId
        name
        contentType
        createdAt
        size
        isImage
        clientId
        isAudio
        duration
        file {
          id
          cdnBaseUrl
          url
          isPreviewable
          thumbnail
        }
        owner {
          id
          name
          firstName
          lastName
          createdAt
        }
      }
      ... on MessageTaskAssignment {
        id
        messageId
        assignees {
          id
          name
          avatar {
            ...AvatarDetail
          }
        }
        task {
          id
          name
          deletedAt
          completedAt
        }
      }
      ... on MessageTaskComplete {
        id
        messageId
        completor {
          id
          name
          avatar {
            ...AvatarDetail
          }
        }
      }
    }
    reaction {
      ... on MessageReaction {
        id
        reaction
        count
        user {
          id
        }
      }
    }
  }
`;
